import {
  applyMiddleware, compose,
  createStore as reduxCreateStore,
} from "redux";
import thunkMiddleware from "redux-thunk";
import * as reducers from "./reducers";
import { combineModels } from "./redux";

const composeEnhancers =
  typeof window === "object" &&
    window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ ?
    window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__({
      // Specify extension’s options like name, actionsBlacklist, actionsCreators, serialize...
    }) : compose;

const middlewares = [
  thunkMiddleware,
];

if (process.env.NODE_ENV === "development") {
  middlewares.push(require("redux-logger").createLogger());
}

const enhancer = composeEnhancers(
  applyMiddleware(...middlewares),
  // other store enhancers if any
);

let __store = null;

export const createStore = (rootReducer = {}) => {
  rootReducer = combineModels({
    ...reducers,
    ...rootReducer,
  });
  return __store = reduxCreateStore(rootReducer, enhancer);
};

export const getState = () => __store.getState();

export const dispatch = (action) => __store.dispatch(action);
